import { useNavigate, useParams } from "react-router-dom";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import PageContainer from "components/PageContainer/PageContainer";
import TableContainerSimple from "Common/Tables/ObjectFiltersTable/TableContainerSimple";
import { useEffect, useState, useMemo } from "react";
import { Axios } from "api/axios";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";

const WarehousewiseStockDetailsPage = () => {
  const { item_id, warehouse_id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchWarehouseStock = async () => {
      setLoading(true);

      try {
        const res = await Axios.get(
          `inventory/in-stock/warehouse-wise-stock?item_id=${item_id}&warehouse_id=${warehouse_id}`
        );

        setData(res.data?.data || []);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };

    if (item_id && warehouse_id) fetchWarehouseStock();
  }, [item_id, warehouse_id]);

  const handleCancel = () => navigate("/inventory-inventory");

  const columns = useMemo(
    () => [
      {
        header: "Sr No",
        accessorKey: "sr_no",
        cell: ({ row }: any) => row.index + 1,
      },
      { header: "Item Name", accessorKey: "item_name" },
      { header: "Item Code", accessorKey: "item_code" },
      { header: "Category", accessorKey: "category" },
      { header: "Subcategory", accessorKey: "subcategory" },
      { header: "Unit", accessorKey: "unit" },
      { header: "Warehouse", accessorKey: "warehouse" },
      { header: "Bag No", accessorKey: "bag_no" },
      { header: "Total Stock", accessorKey: "total_stock" },
    ],
    []
  );

  return (
    <PageContainer>
      <FormHeader
        title="View Warehouse-wise Stock Details"
        firstLabel="Inventory"
        secondLabel="Warehouse-wise Details"
        handleArrowClick={handleCancel}
        handleBreadcrumbClick={handleCancel}
      />

      {loading ? (
        <div className="text-center py-5">
          <LoadingSpinner />
        </div>
      ) : (
        <TableContainerSimple columns={columns} data={data} />
      )}
    </PageContainer>
  );
};

export default WarehousewiseStockDetailsPage;
